import * as ActionTypes from './ActionTypes';
import { fetchWrapper } from '../../_helpers';

const groupVisitsByEmployee = (visits = []) => {
    return visits.reduce((acc, visit) => {
        const empId = visit?.employee?._id;
        if (!empId) return acc;

        if (!acc[empId]) {
            acc[empId] = {
                employee: visit.employee,
                visits: [],
                forms: [],
            };
        }

        acc[empId].visits.push(visit);
        if (visit?.forms) {
            acc[empId].forms.push(...visit.forms);
        }
        return acc;
    }, {});
};

const groupVisitsByEmployeeWithMileage = (visits = []) => {
    return Object.values(
        visits.reduce((acc, visit) => {
            const empId = visit?.employee?._id;
            if (!empId) return acc;

            const mileageData = visit?.extraInfo?.mileageData;
            const directions = visit?.extraInfo?.directions || [];
            const miles = (
                (mileageData?.distance || directions.reduce((sum, dir) => sum + (dir?.distance?.value || 0), 0)) /
                1609.34
            ).toFixed(2);

            if (!acc[empId]) {
                acc[empId] = {
                    employee: visit.employee,
                    miles: 0,
                };
            }

            acc[empId].miles += parseFloat(miles || 0);
            return acc;
        }, {})
    );
};

export const getTeamSummary =
    ({ providerId, team, startDate, endDate }) =>
    async (dispatch) => {
        try {
            const params = new URLSearchParams();
            if (!team) {
                return;
            }

            if (providerId) params.append('provider', providerId);
            if (startDate) params.append('startDate', startDate);
            if (endDate) params.append('endDate', endDate);
            const url = `/analytics/team/${team}/summary?${params.toString()}`;
            const response = await fetchWrapper.get(url);
            const payload = {
                totalEmployees: response?.staffCount || 0,
                totalVisits: response?.visitCount || 0,
                totalFormsSubmitted: response?.userFormDataCount || 0,
                totalSchedules: response?.taskCount || 0,
                loading: false,
            };

            dispatch(setTeamDashboardSummary(payload));
            return true;
        } catch (error) {
            if (error.name !== 'AbortError') {
            }
            return false;
        }
    };

export const getTeamVisits =
    ({ employee, client, provider, page = 1, endDate, startDate, sortBy, team }) =>
    async (dispatch) => {
        try {
            dispatch(setTeamDashboardVisit({ loading: true }));
            const params = new URLSearchParams({
                page,
                limit: 100,
            });

            if (team) params.append('team', team);
            if (employee) params.append('employee', employee);
            if (client) params.append('client', client);
            if (provider) params.append('provider', provider);
            if (sortBy) params.append('sortBy', sortBy);
            if (endDate) params.append('serviceEndAt', endDate);
            if (startDate) params.append('serviceCreatedAt', startDate);

            const url = `evv/visit?${params.toString()}`;
            const response = await fetchWrapper.get(url);
            const payload = {
                ...response,
                groupedVisitsByEmployee: groupVisitsByEmployee(response?.results || []),
                groupedMileageByEmployee: groupVisitsByEmployeeWithMileage(response?.results || {}),
                loading: false,
            };
            dispatch(setTeamDashboardVisit(payload));
            return true;
        } catch (error) {
            if (error.name !== 'AbortError') {
            }
            return false;
        }
    };

export const setTeamDashboardSummary = (data) => ({
    type: ActionTypes.SET_TEAM_DASHBOARD_SUMMARY,
    payload: data,
});

export const setTeamDashboardVisit = (data) => ({
    type: ActionTypes.SET_TEAM_DASHBOARD_VISITS,
    payload: data,
});

export const clearDashboard = () => ({
    type: ActionTypes.CLEAR_DASHBOARD,
});
